var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DailyRewardDropModal',{attrs:{"isVisible":_vm.rewardDropModalVisible},on:{"close":_vm.closeModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }